module.exports = __webpack_public_path__ + "static/media/simple-icon.32a746f0.svg";